import ApiService from "../apiservice";


class EtiquetaService extends ApiService {

    constructor() {
        super('/api/etiqueta');
    }

    consultarEmpresaPorNire(numero) {
        // Ex: GET /api/etiqueta/consulta/empresa/42203768064
        return this.get(`/consulta/empresa/${numero}`);
    }


    // Gera o payload no formato esperado pela API
    async consultarEmpresasPorArquivamentos(listaArquivamentos) {
        const payload = listaArquivamentos.map(protocolo => ({ NR_PROTOCOLO: protocolo }));

        const response = await this.post('/consulta/arquivamento/lista', payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    }


    // Gera o arquivo com as etiquetas de protocolos de 3 colunas
    async gerarEtiqueta(numeroArquivamento) {
        const payload = [{ NR_PROTOCOLO: numeroArquivamento }];

        const response = await this.post('/gerar', payload, {
            headers: {
            'Content-Type': 'application/json'
            }
        });

        return response.data;
        }


}

export default EtiquetaService;